import { type ThemePalette, Themes } from '@shared-core/features/config'

export function normalizeUserTheme(themePalette: unknown): Themes {
  if (themePalette === Themes.dark) return Themes.dark

  if (themePalette === Themes.light) return Themes.light

  if (themePalette === Themes.system) return Themes.system

  return Themes.system
}

export function resolveSystemPalette(): ThemePalette {
  if (typeof window === 'undefined') return 'light'

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function resolveWebColorPalette(
  userThemePalette: Themes,
  systemPalette: ThemePalette = resolveSystemPalette(),
): ThemePalette {
  const normalizedTheme = normalizeUserTheme(userThemePalette)

  if (normalizedTheme === Themes.dark) return 'dark'

  if (normalizedTheme === Themes.light) return 'light'

  return systemPalette
}
